module.exports = __webpack_public_path__ + "assets/fffdb4e1218b99045de4b0daf6d0466b.png";